import { createContext, useContext, useState } from "react";
import type { CreationFilters } from "./creationExploration";

export type CreationControlState = { mode: "value" | "count"; filters: CreationFilters };
export function useLocalCreationControls(initial?: CreationControlState) {
  const [mode, setMode] = useState<"value" | "count">(initial?.mode ?? "value");
  const [filters, setFilters] = useState<CreationFilters>(initial?.filters ?? {});
  return { mode, setMode, filters, setFilters };
}
export const CreationControlsContext = createContext<ReturnType<typeof useLocalCreationControls> | null>(null);
export function useCreationControls() {
  const shared = useContext(CreationControlsContext);
  const local = useLocalCreationControls();
  return shared ?? local;
}
